var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageComposition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71698 2.58935C6.85841 3.2232 9.14192 3.2232 11.2833 2.58935C13.0115 2.07784 13.8755 1.82209 14.2712 2.13948C14.6668 2.45686 14.6668 3.27181 14.6668 4.90171L14.6668 11.0983C14.6668 12.7282 14.6668 13.5431 14.2712 13.8605C13.8755 14.1779 13.0115 13.9222 11.2833 13.4106C9.14192 12.7768 6.85841 12.7768 4.71698 13.4106C2.98886 13.9222 2.1248 14.1779 1.72915 13.8605C1.3335 13.5431 1.3335 12.7282 1.3335 11.0983L1.3335 4.90171C1.3335 3.27181 1.3335 2.45686 1.72915 2.13948C2.1248 1.82209 2.98886 2.07784 4.71698 2.58935Z",
    stroke: "#242429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 13.3337C7.29823 10.562 10.2552 6.88637 14.667 9.64317",
    stroke: "#242428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.66699C6 6.21928 5.55228 6.66699 5 6.66699C4.44772 6.66699 4 6.21928 4 5.66699C4 5.11471 4.44772 4.66699 5 4.66699C5.55228 4.66699 6 5.11471 6 5.66699Z",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageComposition);
export default __webpack_public_path__ + "static/media/image-composition.17f6878f6e6ff8733a314eda5052c874.svg";
export { ForwardRef as ReactComponent };